<div class="page-content page-fill">
  <div class="dx-toolbar mb-3">
    <button (click)="close()" class="btn btn-primary" [hidden]="hasChanges">Close</button>
    <button (click)="save()" class="btn btn-success" [hidden]="!hasChanges">Save</button>
    <button (click)="cancel()" class="btn btn-default" [hidden]="!hasChanges">Cancel</button>
    <h2 class="d-block ms-4">{{ person?.displayName }}</h2>
  </div>
  @if (person) {
    <div>
      <dx-form [formData]="person" [colCount]="2" [labelLocation]="'left'" validationGroup="mainValidationGroup" [readOnly]="readOnly">
        <dxi-item [itemType]="'group'" [colCount]="1" cssClass="xpr-4">
          <dxi-item itemType="group" caption="Name">
            <dxi-item dataField="firstName" [label]="{ text: 'First' }" [isRequired]="true"></dxi-item>
            <dxi-item dataField="lastName" [label]="{ text: 'Last' }" [isRequired]="true"></dxi-item>
            <dxi-item dataField="middleName" [label]="{ text: 'Middle' }"></dxi-item>
            <dxi-item dataField="preferredName" [label]="{ text: 'Preferred' }"></dxi-item>
            <dxi-item dataField="title" editorType="dxSelectBox" [editorOptions]="{ items: titles, valueExpr: 'text', displayExpr: 'text' }"></dxi-item>
            <dxi-item dataField="suffix"></dxi-item>
            <dxi-item dataField="email"></dxi-item>
            <dxi-item dataField="isEmailUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
            <dxi-item dataField="useFamilyAddress" [alignItemLabels]="false" editorType="dxCheckBox"></dxi-item>
          </dxi-item>
          <dxi-item [itemType]="'group'" caption="Address" [visible]="!person.useFamilyAddress">
            <dxi-item dataField="address1"></dxi-item>
            <dxi-item dataField="address2"></dxi-item>
            <dxi-item dataField="city"></dxi-item>
            <dxi-item
              dataField="state"
              [label]="{ text: 'State' }"
              editorType="dxSelectBox"
              [editorOptions]="{ items: states, valueExpr: 'text', displayExpr: 'text' }"
            ></dxi-item>
            <dxi-item dataField="zip"></dxi-item>
            <dxi-item dataField="country"></dxi-item>
          </dxi-item>
          <dxi-item [itemType]="'group'" caption="Phone" [colCount]="3">
            <dxi-item dataField="cellPhone" [label]="{ text: 'Mobile' }" [editorOptions]="phoneOptions" [colSpan]="2"></dxi-item>
            <dxi-item dataField="isCellPhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
            <dxi-item dataField="workPhone" [label]="{ text: 'Work' }" [editorOptions]="phoneOptions" [colSpan]="2"></dxi-item>
            <dxi-item dataField="isWorkPhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
            <dxi-item dataField="homePhone" [label]="{ text: 'Home' }" [editorOptions]="phoneOptions" [colSpan]="2"></dxi-item>
            <dxi-item dataField="isHomePhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
          </dxi-item>
        </dxi-item>
        <dxi-item [itemType]="'group'" [colCount]="1" cssClass="xborder-left xpl-4">
          <dxi-item [itemType]="'group'" [colCount]="2">
            <dxi-item dataField="includeInDirectory" [label]="{ text: 'In Directory' }" editorType="dxCheckBox"></dxi-item>
            <dxi-item dataField="includeForGiving" [label]="{ text: 'Record Giving' }" editorType="dxCheckBox"></dxi-item>
            <!-- <dxi-item dataField="isActive" editorType="dxCheckBox"></dxi-item> -->
          </dxi-item>
          <dxi-item
            dataField="relationshipId"
            [label]="{ text: 'Relation' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: relationships, valueExpr: 'id', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item
            dataField="personStatusId"
            [label]="{ text: 'Status' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: personStatuses, valueExpr: 'id', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item
            dataField="sex"
            [label]="{ text: 'Gender' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: genders, valueExpr: 'value', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item dataField="employer"></dxi-item>
          <dxi-item
            dataField="jobCodeId"
            [label]="{ text: 'Job Code' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: jobCodes, valueExpr: 'id', displayExpr: 'text' }"
          ></dxi-item>
          <dxi-item dataField="envelopeNumber" [label]="{ text: 'Envelope #' }"></dxi-item>
          <dxi-item itemType="empty"></dxi-item>
          <dxi-item [itemType]="'group'" caption="Dates" [colCount]="1">
            <dxi-item dataField="birthDateLocal" [label]="{ text: 'Birthday' }" editorType="dxDateBox"></dxi-item>
            <dxi-item itemType="group" [colCount]="3">
              <dxi-item dataField="baptizedDateLocal" [label]="{ text: 'Baptism' }" editorType="dxDateBox" [colSpan]="2" [disabled]="!person.isBaptized"></dxi-item>
              <dxi-item dataField="isBaptized" [label]="{ text: 'Baptized' }" editorType="dxCheckBox"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="3">
              <dxi-item dataField="professionDateLocal" [label]="{ text: 'Profession' }" editorType="dxDateBox" [colSpan]="2"></dxi-item>
              <dxi-item dataField="isProfessing" [label]="{ text: 'Professing' }" editorType="dxCheckBox"></dxi-item>
            </dxi-item>
            <dxi-item dataField="joinedDateLocal" [label]="{ text: 'Joined' }" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="howJoined" editorType="dxSelectBox" [editorOptions]="{ items: joinedOptions, valueExpr: 'text', displayExpr: 'text' }"></dxi-item>
            <dxi-item
              dataField="schoolId"
              [label]="{ text: 'School' }"
              editorType="dxSelectBox"
              [editorOptions]="{ items: schools, valueExpr: 'id', displayExpr: 'name' }"
            ></dxi-item>
            <dxi-item dataField="graduationDateLocal" [label]="{ text: 'Graduation' }" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="weddingDateLocal" [label]="{ text: 'Wedding' }" editorType="dxDateBox"></dxi-item>
            <dxi-item
              dataField="maritalStatusId"
              [label]="{ text: 'Marriage' }"
              editorType="dxSelectBox"
              [editorOptions]="{ items: maritalStatus, valueExpr: 'id', displayExpr: 'text' }"
            ></dxi-item>
            <dxi-item dataField="deceasedDateLocal" [label]="{ text: 'Deceased Date' }" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="departureDateLocal" [label]="{ text: 'Departure Date' }" editorType="dxDateBox"></dxi-item>
            <dxi-item dataField="lastSafeChurchTrainedLocal" [label]="{ text: 'Last Safe Church Trained' }" editorType="dxDateBox"></dxi-item>
          </dxi-item>
          <dxi-item [itemType]="'group'" caption="Note">
            <dxi-item dataField="note" [editorType]="'dxTextArea'" [editorOptions]="{ height: '150px' }" [label]="{ text: ' ', location: 'top' }"> </dxi-item>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  }
  <!-- <div class="card mt-3">
  <div class="card-body" *ngIf="person">
    <dx-form [formData]="person">
      <dxi-item dataField="note" [editorType]="'dxTextArea'" [editorOptions]="{ height: '150px' }" [label]="{ text: 'Notes' }"> </dxi-item>
    </dx-form>
  </div>
</div> -->
</div>
